module.exports = __webpack_public_path__ + "static/media/DSC01475.bb8ddea7.jpg";